export enum HackerStatus {
  HACKER_STATUS_NONE = 'None',
  HACKER_STATUS_APPLIED = 'Applied',
  HACKER_STATUS_ACCEPTED = 'Accepted',
  HACKER_STATUS_DECLINED = 'Declined',
  HACKER_STATUS_WAITLISTED = 'Waitlisted',
  HACKER_STATUS_CONFIRMED = 'Confirmed',
  HACKER_STATUS_WITHDRAWN = 'Withdrawn',
  HACKER_STATUS_CHECKED_IN = 'Checked-in',
}
export default HackerStatus;
